module.exports = __webpack_public_path__ + "img/Studentrecord.dacd0108.png";